import type { Drill } from '@acepoker/contract'
import { api } from './api'

export const createRoomFromDrill = async (drillId: Drill['id']): Promise<{ id: string }> =>
  await api().url(`/api/drill/${drillId}/room`).post({}).json()
